import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Sugerencia } from './sugerencia.model';

@Injectable()
export class SugerenciaResolver implements Resolve<Sugerencia> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Sugerencia);
      }
      return await this.backendService.get(Sugerencia, Sugerencia.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/sugerencia']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/sugerencia/sugerencia.resolver.ts